import GetSequenceNumberListRequestModelBase from '../_generated/modelBases/get-sequence-number-list-request-model-base';

export default class GetSequenceNumberListRequestModel extends GetSequenceNumberListRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
